import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=0fb68a79&scoped=true&"
import script from "./addContact.vue?vue&type=script&lang=js&"
export * from "./addContact.vue?vue&type=script&lang=js&"
import style0 from "./addContact.vue?vue&type=style&index=0&id=0fb68a79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb68a79",
  null
  
)

export default component.exports